import React, { useState, useEffect } from "react";
import cx from "classnames";
import styles from "../scss/AppFormField.module.scss";
import { IAFSmartAvailableAnswer, IAnswerProps } from "../interfaces/IAppFormData";
import Input from "../../common/components/Forms/Input/Input";

interface IAFTextareaFieldProps {
    question: any;
    answerChanges: (answerParam: IAnswerProps) => void;
    label?: string;
}

const AFTextareaField: React.FC<IAFTextareaFieldProps> = (props) => {
    const { question, answerChanges } = props;

    const [isReady, setIsReady] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [selectedOption, setSelectedOption] = useState("");
    const [options, setOptions] = useState<Array<IAFSmartAvailableAnswer>>();

    const handleFieldValue = (textValue: string): void => {
        setInputValue(textValue);
        answerChanges({
            questionId: question.id,
            answer: textValue,
            disclosure: []
        });
    };

    const filterOptionList = (list: Array<IAFSmartAvailableAnswer>): void => {
        const newList = list.filter((i) => i.value !== "OpenEndedText");
        setOptions(newList);
        setIsReady(true);
    };

    const handleSelectOption = (value: string): void => {
        if (value === selectedOption) {
            setSelectedOption("");
            answerChanges({
                questionId: question.id,
                answer: inputValue,
                disclosure: []
            });
            return;
        }
        setSelectedOption(value);
        answerChanges({
            questionId: question.id,
            answer: value,
            disclosure: []
        });
    };

    const handleDefaulValue = (): void => {
        if (question?.answer) {
            const findOption = question?.availableQuestionAnswers?.find(
                (i) => i.value === question?.answer
            );
            if (findOption?.value) {
                handleSelectOption(findOption?.value);
                return;
            }
            handleFieldValue(question?.answer);
        }
    };

    useEffect(() => {
        if (question?.id) {
            filterOptionList(question?.availableQuestionAnswers);
            handleDefaulValue();
        }
    }, []);

    return (
        <div className={styles["af-textarea-field"]} id={question.id}>
            {!selectedOption && (
                <div className={cx([styles["input-field"]])}>
                    <Input
                        id={props?.label}
                        name={props?.label}
                        type="textarea"
                        value={inputValue || ""}
                        onChange={(e) => {
                            handleFieldValue(e.target.value);
                        }}
                        placeholder={question?.placeholder || ""}
                    />
                </div>
            )}
            {isReady && (
                <div
                    className={styles["af-radio-button"]}
                    id={`radio-group-${question.id}`}>
                    {options.map((opt, idx) => (
                        <div
                            className={styles["checklist-radio-button"]}
                            key={`${idx}${question.id}`}>
                            <input
                                type="radio"
                                id={`${props?.label} ${question.id}`}
                                name={`radio-group-${question.id}`}
                                value={opt.value}
                                checked={selectedOption === opt.value}
                                onClick={() => {
                                    handleSelectOption(opt.value);
                                }}
                                onChange={(e) => {
                                    handleSelectOption(e.target.value);
                                }}
                            />
                            <label
                                className={styles["radion-button--label-container"]}
                                htmlFor={`${props?.label} ${question.id}`}>
                                <p className={styles["rb--label"]}>{opt.displayText}</p>
                            </label>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AFTextareaField;
